const Count = ({num}) => {

    return <>
        <h1>
            {num}
        </h1>
    </>
}


export default Count